import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@hub/services/AuthService';

@Component({
  selector: 'logout',
  template: ''
})
export class LogoutComponent {
  constructor(authService: AuthService, router: Router) {
    sessionStorage.clear();
    localStorage.clear();
    authService.logOut();
    router.navigate(['/login']);
  }
}
